import React from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '@wix/da-ds/pkg/Loader/Loader';
import ProgressBar from '@wix/da-ds/pkg/ProgressBar/ProgressBar';
import { UploaderVariant, VARIANT_CONFIG } from '../types';

import s from './UploadingLoader.scss';

interface Props {
  uploadProgress?: number;
  variant: UploaderVariant;
}

const UploadingLoader: React.FC<Props> = ({ uploadProgress, variant }) => {
  const { t } = useTranslation();
  const { uploadingLoaderState, uploadingTitleKey } = VARIANT_CONFIG[variant];
  return (
    <div className={s['root']}>
      <Loader size="big" state={uploadingLoaderState} />
      {uploadProgress ? (
        <ProgressBar progress={uploadProgress} className={s['progress-bar']} />
      ) : null}
      <div className={s['progress-title']}>{t(uploadingTitleKey)}</div>
    </div>
  );
};

export default UploadingLoader;
